import { createAsyncThunk } from "@reduxjs/toolkit";
import { handleError } from "../../Common/Alerts/errorhandling.action";
import { setShowError } from "../../Common/Alerts/alertsSlice";
import {
  deleteData,
  getData,
  postData,
  putData,
} from "../../../../services/apiEndpoints";
import { getAY } from "../../../../Utils/academivYear";
import { getUserRole } from "../../../../Utils/getRoles";
import toast from "react-hot-toast";


// Fetch all benefits with pagination support
export const fetchbenefitsThunk = createAsyncThunk(
  "benefit/fetchAll",
  async ({ page = 1, limit = 100 }, { rejectWithValue, dispatch, getState }) => {
    try {
      const say = getAY();
      dispatch(setShowError(false));
      const response = await getData(
        `/admin/all/benifit?say=${say}&page=${page}&limit=${limit}`
      );         
      return response ;
    } catch (error) {
      return handleError(error, dispatch, rejectWithValue);
    }
  }
);

// Create new benefit
export const createbenefitThunk = createAsyncThunk(
  "benefit/create",
  async (benefitData, { rejectWithValue, dispatch, getState }) => {
    try {
      const say = getAY();
      dispatch(setShowError(false));
      const response = await postData(
        `/admin/add/benifit?say=${say}`,
        benefitData
      );
      dispatch(fetchbenefitsThunk({ page: 1, limit: 100 }));
      return response;
    } catch (error) {
      return handleError(error, dispatch, rejectWithValue);
    }
  }
);

// Update benefit
export const updatebenefitThunk = createAsyncThunk(
  "benefit/update",
  async (
    { benefitId, updatedData },
    { rejectWithValue, dispatch, getState }
  ) => {
    try {
      const say = getAY();
      dispatch(setShowError(false));
      const response = await putData(
        `/admin/update/benifit/${benefitId}?say=${say}`,
        updatedData
      );
      dispatch(fetchbenefitsThunk({ page: 1, limit: 100 }));
      return response;
    } catch (error) {
      return handleError(error, dispatch, rejectWithValue);
    }
  }
);

// Delete benefit
export const deletebenefitThunk = createAsyncThunk(
  "benefit/delete",
  async (benefitId, { rejectWithValue, dispatch, getState }) => {
    try {
      const say = getAY();
      const getRole = getUserRole(getState);
      dispatch(setShowError(false));
      await deleteData(`/${getRole}/delete/benefit/${benefitId}?say=${say}`);
      toast.success("benefit Delete successfully");
      dispatch(fetchbenefitsThunk({ page: 1, limit: 100 }));
      return ;
    } catch (error) {
      return handleError(error, dispatch, rejectWithValue);
    }
  }
);


